module.exports = __webpack_public_path__ + "media/images/new-ui-images/task-icon-8704a3130d1e3555b98cbbf0f1e91cba.svg";